define('controllers/peoplefinder/Podio.Controllers.PeopleFinder.Main',['require','translate','underscore','backbone','lib/backbone/Backbone.PodioController','views/peoplefinder/Podio.Views.PeopleFinder.Main','views/peoplefinder/Podio.Views.PeopleFinder.Email','views/peoplefinder/Podio.Views.PeopleFinder.Contacts','models/Podio.Models.PeopleFinder','collections/Podio.Collections.ChecklistContacts','lib/backbone/Backbone.Mixins.StateMachine','signals'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var Backbone = require('backbone');
  var PodioController = require('lib/backbone/Backbone.PodioController');
  var PeopleFinderMainView = require('views/peoplefinder/Podio.Views.PeopleFinder.Main');
  var PeopleFinderEmailView = require('views/peoplefinder/Podio.Views.PeopleFinder.Email');
  var PeopleFinderContactsView = require('views/peoplefinder/Podio.Views.PeopleFinder.Contacts');
  var PeopleFinderModel = require('models/Podio.Models.PeopleFinder');
  var ChecklistContactsCollection = require('collections/Podio.Collections.ChecklistContacts');

  var BackboneMixinStateMachine = require('lib/backbone/Backbone.Mixins.StateMachine');
  var signalsLib = require('signals');

  var PeopleFinderMailController = PodioController.extend({

    signals : {
      onDone  : new signalsLib.Signal(),
      onClose : new signalsLib.Signal(),
      onShow  : new signalsLib.Signal()
    },

    states: ['mail', 'podio', 'podioSpaceMembers', 'podioSpaceContacts', 'linkedAccount'],

    enterState: {
      mail: 'enterMail',
      podio: 'enterPodio',
      podioSpaceMembers: 'enterPodioSpaceMembers',
      podioSpaceContacts: 'enterPodioSpaceContacts',
      linkedAccount: 'enterLinkedAccount'
    },

    leaveState: {
      mail: 'leaveState',
      podio: 'leaveContactState',
      podioSpaceMembers: 'leaveContactState',
      podioSpaceContacts: 'leaveContactState',
      linkedAccount: 'leaveContactState'
    },

    stateDataBuckets : {
      'mail'          : 'mail',
      'podio'         : 'user',
      'podioSpaceMembers': 'user',
      'podioSpaceContacts': 'profile',
      'linkedAccount' : 'external'
    },

    bindEvents: function() {
      this.eventBus.bind('sideTabsLinkedAccountsLayout:providerChanged', this.onProviderChanged, this);
      this.eventBus.bind('sideTabsLayout:doneTriggered', this.onDoneTriggered, this);
      this.eventBus.bind('sideTabsLayout:cancelTriggered', this.onCancelTriggered, this);
      this.eventBus.bind('sideTabsLayout:navigationRendered', this.onNavigationRendered, this);
      this.eventBus.bind('sideTabsLayout:accountConnected', this.onAccountConnected, this);
      this.eventBus.bind('sideTabsLinkedAccountsLayout:accountChanged', this.onAccountChanged, this);
      this.eventBus.bind('peopleFinderContacts:contactChecked', this.onContactChecked, this);
      this.eventBus.bind('peopleFinderContacts:contactUnchecked', this.onContactUnchecked, this);
      this.eventBus.bind('peopleFinderEmail:emailAdded', this.onEmailAdded, this);
      this.eventBus.bind('peopleFinderEmail:emailRemoved', this.onEmailRemoved, this);
    },

    initialize: function(config) {
      this.eventBus = _.extend({}, Backbone.Events);
      this.bindEvents();

      this.model = new PeopleFinderModel();
      this.config = config;

      this.peopleFinderView = new PeopleFinderMainView({
        eventBus: this.eventBus,
        config: config
      });
    },

    formatters : {

      formatByContext: function(state, object) {
        var formatted;

        switch (state) {
        case 'linkedAccount':
          formatted = this.formatExternal(object);
          break;
        case 'podio':
        case 'podioSpaceMembers':
          formatted = this.formatUser(object);
          break;
        case 'podioSpaceContacts':
          formatted = this.formatContact(object);
          break;
        case 'mail':
          formatted = this.formatEmail(object);
          break;
        }

        return formatted;
      },

      formatExternal: function(object) {
        var data = {
          id: object.id,
          name: object.get('name'),
          ref_type : 'external',
          itemIcon: object.get('avatar'),
          external_contact_id : object.id,
          linked_account_id : object.get('provider_id')
        };

        return data;
      },

      formatUser: function(object) {
        var data = {
          id: object.id,
          name: object.get('name'),
          ref_type : 'user',
          itemIcon: object.get('avatar')
        };

        return data;
      },

      formatContact: function(object) {
        var data = {
          id: object.id,
          name: object.get('name'),
          ref_type : 'profile',
          itemIcon: object.get('avatar')
        };

        return data;
      },

      formatEmail: function(object) {
        var data = {
          id: object,
          name: object,
          ref_type : 'mail'
        };

        return data;
      }
    },

    storeSingleItem: function(object, isAdding) {
      var dataGroup = this.stateDataBuckets[this.currentState];
      var data = this.formatters.formatByContext(this.currentState, object);

      if (isAdding) {
        this.model.addItem(data, dataGroup);
      } else {
        this.model.removeItem(data, dataGroup);
      }
    },

    storeData: function(object, isAdding) {

      if ( _.isArray(object)) {
        _.each(object, function(item) {
          this.storeSingleItem(item, isAdding);
        }, this);
      } else {
        this.storeSingleItem(object, isAdding);
      }

      this.refreshCountBadges();
    },

    groupDataPerProvider: function(data) {
      var providerCounts = {};

      _.each(data, function(item) {
        var linkedAccount = this.peopleFinderView.linkedAccounts.get(item.linked_account_id);

        if (linkedAccount) {
          var providerName = linkedAccount.get('provider');

          if ( providerCounts[providerName] ) {
            providerCounts[providerName].push(item);
          } else {
            providerCounts[providerName] = [item];
          }
        }
      }, this);

      return providerCounts;
    },

    refreshCountBadges: function() {

      this.peopleFinderView.resetCounters();

      _.each(this.model.attributes, function(data, key) {
        var choice;

        switch (key) {
        case 'user':
          if (this.configTypeProperty('podioSpaceMembers', 'visible')) {
            choice = 'podioSpaceMembers';
          } else {
            choice = 'podio';
          }
          this.peopleFinderView.setCounter(choice, data.length);
          break;
        case 'external':
            // Prepare data
          var providerCounts = this.groupDataPerProvider(data);
            // Update counters
          _.each(providerCounts, function(list, provider) {
            this.peopleFinderView.setCounter(provider, list.length);
          }, this);
          break;
        case 'profile':
          this.peopleFinderView.setCounter('podioSpaceContacts', data.length);
          break;
        default:
          this.peopleFinderView.setCounter(key, data.length);
        }
      }, this);
    },

    // Public methods

    show: function() {
      var self = this;

      var dfdFinderShowRendered = this.peopleFinderView.show();

      var firstNavOption = this.peopleFinderView.getFirstNavigationOption();
      if (firstNavOption) {
        self.toState(firstNavOption.id);
      }

      dfdFinderShowRendered.done(function(navigationOptions) {
        if (! firstNavOption) {
          // Assume we only have linked accounts, show first
          self.peopleFinderView.showFirstLinkedAccount();
        }
        self.signals.onShow.dispatch();
      });
    },

    destroy: function() {
      if (this.peopleFinderView) {
        this.peopleFinderView.dispose();
        delete this.peopleFinderView;
      }
    },

    populate: function(data) {
      this.model.set(data);
    },

    // State handlers

    enterMail: function() {
      this.currentView = new PeopleFinderEmailView({
        el: this.peopleFinderView.getContentEl(),
        model: this.model,
        eventBus: this.eventBus
      });
    },

    enterPodio: function() {
      this.initContactsViewAndCollection('podio');
    },

    enterPodioSpaceMembers: function() {
      this.initContactsViewAndCollection('podioSpaceMembers');
    },

    enterPodioSpaceContacts: function() {
      this.initContactsViewAndCollection('podioSpaceContacts');
    },

    enterLinkedAccount: function(oldState, providerName) {
      var linkedAccountId = this.peopleFinderView.getCurrentLinkedAccountId(providerName);

      var cc = new ChecklistContactsCollection(null, { linkedAccountId: linkedAccountId, contactable: this.configTypeProperty('linkedAccounts', 'contactable') });

      // render
      this.currentView = new PeopleFinderContactsView({
        el: this.peopleFinderView.getContentEl(),
        contactsCollection: cc,
        contactsReady : cc.getContacts(),   /* fetch */
        model: this.model,
        eventBus: this.eventBus,
        providerName: providerName,
        dataGroup: this.stateDataBuckets['linkedAccount']
      });

      this.currentView.render();
    },

    leaveCurrentState: function() {
      if (!this.currentView) {
        return;
      }

      this.currentView.destroy();
      delete this.currentView;
    },

    leaveContactState: function() {

      // Reject promise so an unfinished ajax request won't result in rendering the contacts collection after we have left the tab.
      this.currentView.contactsReady.reject();

      this.leaveCurrentState();
    },

    // Convenience methods

    getConfigByType: function(type) {
      return _.find(this.config, function(c) {
        return c.type === type;
      });
    },

    configTypeProperty: function(type, property) {
      var c = this.getConfigByType(type);
      if (c) {
        return c[property];
      }
    },

    initContactsViewAndCollection: function(type) {
      var cc = new ChecklistContactsCollection(null, this.getConfigByType(type));

      // render
      this.currentView = new PeopleFinderContactsView({
        el: this.peopleFinderView.getContentEl(),
        contactsCollection: cc,
        contactsReady : cc.getContacts(),   /* fetch */
        model: this.model,
        eventBus: this.eventBus,
        dataGroup: this.stateDataBuckets[type],
        emptyCollectionBlankslate: type === 'podio' ? t('You have no Podio contacts. Use the sidebar to find people by email instead #invite') : t('No contacts could be found #peoplefinder')
      });

      this.currentView.render();
    },

    // Event handlers

    onProviderChanged: function(providerName, provider) {
      var regularStates = ['mail', 'podio', 'podioSpaceMembers', 'podioSpaceContacts'];

      if (_.include(regularStates, providerName)) {
        this.toState(providerName);
      } else {
        this.toState('linkedAccount', null, providerName);
      }
    },

    onAccountChanged: function(providerName, linkedAccountId) {
      this.toState('linkedAccount', null, providerName);
    },

    onDoneTriggered: function() {
      this.signals.onDone.dispatch(this.model);
      this.destroy();
    },

    onCancelTriggered: function() {
      this.peopleFinderView.hide();
      this.signals.onClose.dispatch();
    },

    onContactChecked: function(contact) {
      this.storeData(contact, true);
    },

    onContactUnchecked: function(contact) {
      this.storeData(contact, false);
    },

    onEmailAdded: function(email) {
      this.storeData(email, true);
    },

    onEmailRemoved: function(email) {
      this.storeData(email, false);
    },

    onNavigationRendered: function() {
      this.refreshCountBadges();
    },

    onAccountConnected: function(providerName, linkedAccount) {
      this.toState('linkedAccount', null, providerName);
    }

  });

  _.extend(PeopleFinderMailController.prototype, BackboneMixinStateMachine);

  return PeopleFinderMailController;

});

